import React from "react";

const EmojiPickerContext = React.createContext();

export const useEmojiPicker = () => React.useContext(EmojiPickerContext);

export const EmojipickerProvider = ({ children }) => {
  const [emojiPickerOpen, setEmojiPicker] = React.useState(null);
  const value = {
    emojiPickerOpen,
    setEmojiPicker,
  };
  return (
    <EmojiPickerContext.Provider value={value}>
      {children}
    </EmojiPickerContext.Provider>
  );
};
